var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"spinner",attrs:{"aria-label":"loading","width":24,"height":24,"xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-width":"2"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"10","stroke-opacity":".5"}}),_c('path',{attrs:{"d":"m12 2a10 10 0 0 1 10 10"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }